interface MenuLinks {
	href: string;
	label: string;
}

export const institutionalMenuLinks: MenuLinks[] = [
	{
		href: 'https://assurance-maladie.ameli.fr/qui-sommes-nous',
		label: 'Qui sommes-nous ?'
	},
	{
		href: 'https://assurance-maladie.ameli.fr/carrieres',
		label: 'Carrières'
	},
	{
		href: 'https://assurance-maladie.ameli.fr/etudes-et-donnees',
		label: 'Études et données'
	},
	{
		href: 'https://assurance-maladie.ameli.fr/presse',
		label: 'Presse'
	}
];

export const healthProLinks: MenuLinks[] = [
	{
		href: 'https://www.ameli.fr/chirurgien-dentiste',
		label: 'Chirurgien-dentiste'
	},
	{
		href: 'https://www.ameli.fr/etablissement',
		label: 'Établissement'
	},
	{
		href: 'https://www.ameli.fr/exercice-coordonne',
		label: 'Exercice coordonné'
	},
	{
		href: 'https://www.ameli.fr/infirmier',
		label: 'Infirmier'
	},
	{
		href: 'https://www.ameli.fr/laboratoire-danalyses-medicales',
		label: 'Laboratoire d’analyses médicales'
	},
	{
		href: 'https://www.ameli.fr/masseur-kinesitherapeute',
		label: 'Masseur kinésithérapeute'
	},
	{
		href: 'https://www.ameli.fr/medecin',
		label: 'Médecin'
	},
	{
		href: 'https://www.ameli.fr/orthophoniste',
		label: 'Orthophoniste'
	},
	{
		href: 'https://www.ameli.fr/orthoptiste',
		label: 'Orthoptiste'
	},
	{
		href: 'https://www.ameli.fr/pedicure-podologue',
		label: 'Pédicure-podologue'
	},
	{
		href: 'https://www.ameli.fr/pharmacien',
		label: 'Pharmacien'
	},
	{
		href: 'https://www.ameli.fr/professionnel-de-la-lpp',
		label: 'Professionnel de la LPP'
	},
	{
		href: 'https://www.ameli.fr/psychologue',
		label: 'Psychologue'
	},
	{
		href: 'https://www.ameli.fr/sage-femme',
		label: 'Sage-femme'
	},
	{
		href: 'https://www.ameli.fr/taxi-conventionne',
		label: 'Taxi conventionné'
	},
	{
		href: 'https://www.ameli.fr/transporteur-sanitaire',
		label: 'Transporteur sanitaire'
	}
];
